import React, { useEffect, useState } from "react";
import { FiUser } from "react-icons/fi";

import {
  IoCalendarOutline,
  IoCloseOutline,
  IoSchoolOutline,
} from "react-icons/io5";
import { toast } from "react-toastify";
import { assignChild } from "../../store/slices/Customer/thunk";
import { useDispatch } from "react-redux";
import "./../AddChild.tsx/AddChild.scss";
interface AddParentProps {
  onClose: () => void;
  customerId: string | undefined;
}
const AddChild: React.FC<AddParentProps> = ({ onClose, customerId }) => {
  const [childData, setChildData] = useState({
    childName: "",
    age: "",
    schoolName: "",
    gender: "male",
    rollNo: "",
  });
  const dispatch: any = useDispatch();

  const [additionalInfo, setAdditionalInfo] = useState<any[]>([]);

  const addChild = () => {
    if (
      !childData.childName ||
      childData.age === "" ||
      childData.schoolName === "" ||
      childData.gender === "" ||
      childData.rollNo === ""
    ) {
      return toast.error("Please fill all child fields");
    }

    setAdditionalInfo((prev) => [...prev, childData]);

    setChildData({
      childName: "",
      age: "",
      schoolName: "",
      gender: "male",
      rollNo: "",
    });
  };

  const removeChild = (index: number) => {
    setAdditionalInfo((prev) => prev.filter((_, i) => i !== index));
  };

  const handleChildChange = (e: any) => {
    const { name, value } = e.target;
    setChildData({ ...childData, [name]: value });
  };
  const handleAssignCustomer = async () => {
    try {
      if (additionalInfo.length > 0) {
        let response = await dispatch(assignChild(customerId, additionalInfo));
        if (response && response.data && response.isSuccess) {
          toast.success("Parents assign successfully");
          onClose();
        } else {
          toast.error("Add Child");
        }
      }
    } catch (error) {
      toast.error("Error");
    }
  };
  useEffect(() => {
    console.log(customerId);
  }, [customerId]);
  return (
    <div className="d-flex flex-column gap-4 py-3 align-items-center justify-content-center">
      <div className="AddNewChildrenBox">
        <div className="d-flex align-items-baseline gap-3">
          <div className="UserIcon">
            <FiUser />
          </div>
          <h4>Add New Children</h4>
        </div>
        <div className="InputFields">
          <div className="d-flex flex-column">
            <p className="Name">Child Name</p>
            <input
              type="text"
              name="childName"
              className="input"
              value={childData.childName}
              onChange={handleChildChange}
              placeholder="Enter Name..."
            />
          </div>

          <div className="d-flex flex-column">
            <p className="Name">Age</p>
            <input
              placeholder="Enter age..."
              type="number"
              name="age"
              className="input"
              value={childData.age}
              onChange={handleChildChange}
            />
          </div>

          <div className="d-flex flex-column">
            <p className="Name">School Name</p>
            <input
              type="text"
              name="schoolName"
              className="input"
              value={childData.schoolName}
              onChange={handleChildChange}
              placeholder="Enter School Name..."
            />
          </div>

          <div className="d-flex flex-column">
            <p className="Name"> Gender</p>
            <select
              className="input"
              name="gender"
              value={childData.gender}
              onChange={handleChildChange}
            >
              <option value="male">Male</option>
              <option value="feMale">Female</option>
              <option value="other">Other</option>
            </select>
          </div>

          <div className="d-flex flex-column">
            <p className="Name">Roll No</p>
            <input
              type="text"
              className="input"
              name="rollNo"
              value={childData.rollNo}
              onChange={handleChildChange}
              placeholder="Enter Roll No..."
            />
            <button className="AddChild mt-4" onClick={addChild}>
              Add Child
            </button>
          </div>
        </div>
      </div>

      {additionalInfo?.length > 0 && (
        <h4 className="Title">
          <IoCalendarOutline className="TitleIcon" /> Children Added (
          {additionalInfo?.length})
        </h4>
      )}
      {additionalInfo?.length > 0 && (
        <div className="ChildrenBox">
          {additionalInfo?.map((child: any, index: number) => (
            <div className="ChildCard">
              <div className="Header">
                {/* <div className="Profile">
              <p>A</p>
            </div> */}

                <div className="Info">
                  <h5 className="Name">{child?.childName}</h5>
                  <span className="Gender">
                    {child?.gender == "male"
                      ? "Male"
                      : child.gender == "feMale"
                      ? "Female"
                      : child.gender == "other"
                      ? "Other"
                      : ""}
                  </span>
                </div>

                <IoCloseOutline
                  onClick={() => removeChild(index)}
                  className="CloseIcon"
                />
              </div>

              <div className="Details">
                <p className="Row">
                  <IoCalendarOutline className="Icon" /> <strong>Age:</strong>{" "}
                  {child?.age} years
                </p>
                <p className="Row">
                  <IoSchoolOutline className="Icon" /> <strong>School:</strong>{" "}
                  {child?.schoolName}
                </p>
                <p className="Row">
                  <IoCalendarOutline className="Icon" />{" "}
                  <strong>Roll No:</strong> {child?.rollNo}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="d-flex w-100 gap-2 justify-content-end px-2 assign-Btn-Cont">
        <button className="close-Btn" onClick={onClose}>
          Close
        </button>
        <button className="assignChild" onClick={handleAssignCustomer}>
          Assign Child
        </button>{" "}
      </div>
    </div>
  );
};

export default AddChild;
